import { api } from "./api";

export const dashBoardDataApi = (params) => {
    return api.post(`/core/dashboard`, params);
  };